var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2632 0.5C11.6421 0.5 10.3158 1.82632 10.3158 3.44737V3.87474C6.07158 5.12737 2.94737 9.07684 2.94737 13.7632V22.6053L0 25.5526V27.0263H13.7789C13.4389 26.0808 13.2644 25.0837 13.2632 24.0789H5.89474V13.7632C5.89474 9.69579 9.19579 6.39474 13.2632 6.39474C17.3305 6.39474 20.6316 9.69579 20.6316 13.7632V15.3695C21.6062 15.1937 22.6044 15.1937 23.5789 15.3695V13.7632C23.5789 9.07684 20.4547 5.12737 16.2105 3.87474V3.44737C16.2105 2.66568 15.9 1.916 15.3473 1.36326C14.7945 0.810525 14.0448 0.5 13.2632 0.5ZM20.6316 18.1842V22.6053H16.2105V25.5526H20.6316V29.9737H23.5789V25.5526H28V22.6053H23.5789V18.1842M10.3158 28.5C10.3159 29.1294 10.5174 29.7422 10.8909 30.2487C11.2644 30.7553 11.7903 31.129 12.3915 31.3151C12.9927 31.5013 13.6377 31.4901 14.2321 31.2831C14.8265 31.0762 15.3391 30.6845 15.6947 30.1653C15.2232 29.6642 14.8105 29.1042 14.4568 28.5H10.3158Z",
    fill: "url(#paint0_linear_2421_4802)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2421_4802",
    x1: 0,
    y1: 0.5,
    x2: 30.7927,
    y2: 28.3604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAlert);
export default __webpack_public_path__ + "static/media/addAlert.c201b37f645ed2eefaad4fb33b26360b.svg";
export { ForwardRef as ReactComponent };